import React from 'react';

function ShapeElement({ element, isPreviewMode }) {
  const { style = {} } = element;
  const shapeType = element.shapeType || style.shapeType || 'rectangle';
  
  // Special handling for line shape to ensure it takes full width of its container
  const isLineShape = shapeType === 'line';
  
  // Base styles for all shapes
  const baseStyle = {
    width: '100%',
    height: '100%',
    backgroundColor: style.fill || style.backgroundColor || '#3b82f6',
    opacity: style.opacity !== undefined ? style.opacity : 1,
    boxShadow: style.boxShadow || 'none'
  };
  
  // Special styles for line in preview mode - keep within the grid
  const lineStyle = isPreviewMode && isLineShape ? {
    width: '100%',
    maxWidth: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    transform: 'none'
  } : {};
  
  return (
    <div 
      className={`shape-element shape-${shapeType} ${isLineShape ? 'line-element' : ''}`}
      style={{
        ...baseStyle,
        ...lineStyle
      }}
    ></div>
  );
}

export default ShapeElement; 